var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{class:['k-calendar-td', _vm.cellClass],style:(_vm.cellStyle),attrs:{"title":_vm.title,"role":"gridcell"},on:{"click":_vm.handleClick}},[_c('span',{staticClass:"k-link"},[_vm._v(" "+_vm._s(_vm.formattedValue)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }